import { call, put } from 'redux-saga/effects'

import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { getCompanyProductListSucceed, requestFailure } from '../actions'

export function* getCompanyProductListSaga(
  productApi: {
    getCompanyProductList: (...args: any[]) => any
  },
  {
    payload: { companyId, page, limit, sortBy, sortDirection, isDeleted }
  }: {
    payload: {
      companyId: string
      page?: number
      limit?: number
      sortBy?: string
      sortDirection?: string
      isDeleted?: boolean
    }
  }
) {
  try {
    const { data } = yield call(
      productApi.getCompanyProductList,
      companyId,
      page,
      limit,
      sortBy,
      sortDirection,
      isDeleted
    )
    yield put(getCompanyProductListSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
